function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-media-bar",
  transform: "translate(-78.000000, -9.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.578125,22.046875 L81.578125,15.328125 C81.578125,13.1953125 82.7109375,12.078125 84.8515625,12.078125 L91.5078125,12.078125 L91.5078125,11.90625 C91.5078125,10.3828125 90.7109375,9.59375 89.1484375,9.59375 L81.2421875,9.59375 C79.671875,9.59375 78.8828125,10.3828125 78.8828125,11.921875 L78.8828125,19.71875 C78.8828125,21.265625 79.671875,22.046875 81.234375,22.046875 L81.578125,22.046875 Z M92.875,25.6328125 C94.4375,25.6328125 95.234375,24.84375 95.234375,23.3046875 L95.234375,15.4453125 C95.234375,13.8984375 94.4375,13.1171875 92.875,13.1171875 L84.96875,13.1171875 C83.3984375,13.1171875 82.609375,13.8984375 82.609375,15.4453125 L82.609375,23.3046875 C82.609375,24.8515625 83.3984375,25.6328125 84.96875,25.6328125 L92.875,25.6328125 Z M88.9375,22.6953125 C88.578125,22.6953125 88.296875,22.4140625 88.296875,22.03125 L88.296875,20.0234375 L86.265625,20.0234375 C85.90625,20.0234375 85.59375,19.7109375 85.59375,19.359375 C85.59375,19.0234375 85.90625,18.7109375 86.265625,18.7109375 L88.296875,18.7109375 L88.296875,16.7109375 C88.296875,16.3359375 88.578125,16.046875 88.9375,16.046875 C89.2890625,16.046875 89.5703125,16.3359375 89.5703125,16.7109375 L89.5703125,18.7109375 L91.5390625,18.7109375 C91.9296875,18.7109375 92.25,19.0078125 92.25,19.359375 C92.25,19.71875 91.9296875,20.0234375 91.5390625,20.0234375 L89.5703125,20.0234375 L89.5703125,22.03125 C89.5703125,22.4140625 89.2890625,22.6953125 88.9375,22.6953125 Z",
  id: "duplicated"
})));

function SvgIconDeduplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "duplicated") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeduplicate);
export default __webpack_public_path__ + "static/media/icon_deduplicate.ea7b702a.svg";
export { ForwardRef as ReactComponent };